/**
 * [DLA KOGO 2026-09-19] JEDNA DANA — JEDNO MIEJSCE: opis pola „Dla kogo” w zapotrzebowaniu na sprzęt.
 *
 * Polecenie właściciela: „w sekcji: Utwórz nowe zgłoszenie – Dla kogo * – tutaj wybieramy od razu
 * pracownika z systemu, wpisujemy jego dane lub nie, oraz możemy wskazać dział – tak by to się od
 * razu mapowało.”
 *
 * 🔴 DLACZEGO OSOBNY MODUŁ, A NIE DWA SKLEJANIA W MODALU. Ta sama dana jedzie do serwera DWIEMA
 * drogami: w treści zgłoszenia (HTML, to widzi obsługa w wątku) i w `FormDataJson` (to widzi obsługa
 * w bloku „Dane formularza” i to da się filtrować). Gdyby każda droga składała napis po swojemu,
 * pierwsza poprawka rozjechałaby je po cichu — w wątku byłoby co innego niż w danych formularza.
 * Dlatego napisy powstają TU, a modal tylko je wstawia.
 *
 * 🔴 DZIAŁ JEST TEKSTEM, NIE KLUCZEM OBCYM. Działów w aplikacji są dwa, w książce O365 — 79.
 * Zakładanie brakujących wierszy `Departments` NADAWAŁOBY UPRAWNIENIA (uprawnienie da się nadać
 * działowi, z kaskadą na poddziały). Pole „Dział” przy „Dla kogo” opisuje więc, dla kogo jest sprzęt,
 * i niczego nie otwiera.
 */

/** Źródła działu. Trzy pierwsze przychodzą z serwera (`/users/search`), czwarte powstaje w oknie. */
export const ZRODLO_DZIALU = {
    PRZYPISANIE: "przypisanie",
    KSIAZKA: "ksiazka",
    BRAK: "brak",
    RECZNIE: "recznie",
};

/** Świeża pozycja zapotrzebowania — pola „dla kogo” w stanie pustym. */
export const PUSTE_DLA_KOGO = {
    forWhom: "",
    forWhomUserId: null,
    forWhomDepartment: "",
    forWhomDepartmentSource: "",
};

/**
 * Zdanie dla CZŁOWIEKA pod polem działu. Przypadek „nie ustaliliśmy” ma własny, wyraźny komunikat —
 * puste pole bez słowa wyjaśnienia wygląda dokładnie tak samo jak usterka wyszukiwarki, a na
 * produkcji będzie to przypadek CZĘSTY (11 przypisań działu na 322 czynne konta, pomiar 19.09).
 */
export const komunikatZrodlaDzialu = (zrodlo) => {
    switch (zrodlo) {
        case ZRODLO_DZIALU.PRZYPISANIE:
            return "Dział podstawiony z przypisania w aplikacji.";
        case ZRODLO_DZIALU.KSIAZKA:
            return "Dział podpowiedziany z książki adresowej Office 365 — sprawdź i popraw, jeśli trzeba.";
        case ZRODLO_DZIALU.BRAK:
            return "Nie udało się ustalić działu tej osoby — wpisz go ręcznie.";
        case ZRODLO_DZIALU.RECZNIE:
            return "Dział wpisany ręcznie.";
        default:
            return "";
    }
};

/** Krótka etykieta źródła doklejana do działu w treści zgłoszenia (obsługa wie, skąd to się wzięło). */
export const etykietaZrodlaDzialu = (zrodlo) => {
    switch (zrodlo) {
        case ZRODLO_DZIALU.PRZYPISANIE:
            return "z przypisania w aplikacji";
        case ZRODLO_DZIALU.KSIAZKA:
            return "z książki O365";
        case ZRODLO_DZIALU.RECZNIE:
            return "wpisany ręcznie";
        default:
            return "";
    }
};

/**
 * Kogo dotyczy pozycja. Powiązanie z kontem jest CZĘŚCIĄ tej danej: „Jan Kowalski” bez numeru konta
 * nie mówi obsłudze, którego Jana Kowalskiego dotyczy sprzęt, a w firmie jest ich kilku.
 */
export const opisOsobyDlaKogo = (pozycja) => {
    const nazwa = (pozycja?.forWhom || "").trim();
    if (!nazwa) return "—";
    return pozycja?.forWhomUserId
        ? `${nazwa} (konto #${pozycja.forWhomUserId})`
        : `${nazwa} (spoza aplikacji)`;
};

/** Dział pozycji ze źródłem. Brak działu mówi o sobie wprost, zamiast znikać z listy. */
export const opisDzialuDlaKogo = (pozycja) => {
    const dzial = (pozycja?.forWhomDepartment || "").trim();
    if (!dzial) return "nie ustalono";
    const etykieta = etykietaZrodlaDzialu(pozycja?.forWhomDepartmentSource);
    return etykieta ? `${dzial} (${etykieta})` : dzial;
};

/**
 * Wpisy do `FormDataJson` zgłoszenia. To JEDYNA droga, którą „dla kogo” dojeżdża do BAZY w postaci
 * odczytywalnej maszynowo: `AdditionalData` serwer rozbiera wyłącznie dla wniosku o dostęp do zasobów
 * (typ 2) i nigdzie go nie zapisuje, a `Ticket.FormDataJson` ląduje w kolumnie i renderuje się w
 * karcie zgłoszenia jako blok „Dane formularza”.
 */
export const daneDlaKogoDoFormularza = (pozycje) => {
    const dane = {};
    (Array.isArray(pozycje) ? pozycje : []).forEach((poz, i) => {
        const nazwa = (poz?.forWhom || "").trim();
        if (!nazwa) return;
        dane[`Poz. ${i + 1} — dla kogo`] = opisOsobyDlaKogo(poz);
        dane[`Poz. ${i + 1} — dział`] = opisDzialuDlaKogo(poz);
    });
    return dane;
};
